import { render } from "./FeaturedBlock.vue?vue&type=template&id=943fa702"
import script from "./FeaturedBlock.vue?vue&type=script&lang=js"
export * from "./FeaturedBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/FeaturedBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "943fa702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('943fa702', __exports__)) {
    api.reload('943fa702', __exports__)
  }
  
  module.hot.accept("./FeaturedBlock.vue?vue&type=template&id=943fa702", () => {
    api.rerender('943fa702', render)
  })

}


export default __exports__